export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_00.bb9294f6.jpg";